import React from 'react';
import '../styles/contact.css';

const Contact = () => {
    return (
        <div className='contact'>
            <div className='contact-header'>
                <h1 className='contact-header-title'>Want more <br /> information ?</h1>
                <p className='contact-header-description'>We can inform you on our product</p>
            </div>
            <div className='contact-indian-office'>
                <h2 className='contact-indian-office-title'>Indian office</h2>
                <p className='contact-indian-office-address'>Padma Herbals Pvt. Ltd,<br />
                    Mahatma Gandhi University<br /> Innovation Foundation,<br /> Building No. 10/572, Priyadarshini<br /> Hills, Athirampuzha, Kottayam,<br />
                    Kerala 686560, India
                </p>
                <p className='contact-european-office-email'><span className='bold'>Email: </span>admin@padmagroups.com</p>
                <p className='contact-european-office-phone'><span className='bold'>Phone: </span> +91 85 9402 3331</p>
            </div>
            <div className='contact-european-office'>
                <h2 className='contact-european-office-title'>European office</h2>
                <p className='contact-european-office-name'>Liposomia</p>
                <p className='contact-european-office-address'>145, rue de la Marbrerie <br />
                    34740 VENDARGUES <br />
                    FRANCE
                </p>
                <p className='contact-european-office-email'><span className='bold'>Email:</span> export@next-lab.fr</p>
                <p className='contact-european-office-phone'><span className='bold'>Phone:</span> +39 351 524 8955</p>
            </div>
        </div>
    );
};

export default Contact;